import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../analyzeSlice";

export default function ActiveScenariosCheckbox() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const { isActiveScenario } = state;

	function handleCheck(event) {
		dispatch(setState("isActiveScenario", !isActiveScenario));
	}

	return (
		<Box
			sx={{
				width: 220,
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
			}}
		>
			<FormControlLabel
				control={
					<Checkbox
						checked={isActiveScenario}
						onChange={handleCheck}
						inputProps={{ "aria-label": "controlled" }}
						sx={{ mt: 0.3, mr: -2, }}
					/>
				}
				//override default margin
				sx={{ ml: 0, mr: 0 }}
			/>
			<Typography sx={{ mt: 1.5, transform: "translate(-20px, 0px)", }} >Active Scenarios Only</Typography>
		</Box>
	);
}
